<ion-content>
  <div class="content">
    <div class="box">
      <img src="assets/app-off.svg">
      <div class="title">
        Sentimos muito! mas esse APP foi desabilitado
      </div>
      <div class="text">
        Volte mais tarde até que o aplicativo tenha voltado ao ar
      </div>
    </div>
  </div>
</ion-content>
